import type { Toast as ToastType, ToastType as ToastTypeEnum } from "./toast.service";
import { colors } from "@/theme/tokens/colors";

interface ToastProps {
  toast: ToastType;
  onRemove: (id: string) => void;
}

export const Toast = ({ toast, onRemove }: ToastProps) => {
  const getToastStyles = () => {
    const baseStyles: React.CSSProperties = {
      padding: "12px 16px",
      borderRadius: "8px",
      marginBottom: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      minWidth: "min(300px, 100%)",
      maxWidth: "min(500px, 100%)",
      width: "fit-content",
      pointerEvents: "auto",
      animation: "slideIn 0.3s ease-out",
    };

    const typeStyles: Record<ToastTypeEnum, React.CSSProperties> = {
      success: {
        backgroundColor: colors.success,
        color: "#ffffff",
      },
      error: {
        backgroundColor: colors.error,
        color: "#ffffff",
      },
      info: {
        backgroundColor: colors.info,
        color: "#ffffff",
      },
      warning: {
        backgroundColor: colors.warning,
        color: "#ffffff",
      },
    };

    return { ...baseStyles, ...typeStyles[toast.type] };
  };

  return (
    <div style={getToastStyles()}>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <span>{toast.message}</span>
      <button
        onClick={() => onRemove(toast.id)}
        style={{
          background: "transparent",
          border: "none",
          color: "#ffffff",
          cursor: "pointer",
          fontSize: "18px",
          marginLeft: "12px",
          padding: "0 4px",
        }}
        aria-label="Close toast"
      >
        ×
      </button>
    </div>
  );
};
